import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../../assets/Cornerimage.svg';
import { useTranslation } from 'react-i18next';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

import UXL from '../../components/UXL';
import Loader from '../../components/Loader';

import StatisticsHeadBlackSVG from '../../assets/StatisticsHeadBlack.png';
import StatisticsHeadGreenSVG from '../../assets/StatisticsHeadGreen.png';
import StatisticsHeadYellowSVG from '../../assets/StatisticsHeadYellow.png';

import { getUser } from '../../utils/Auth';
import Api from '../../api';

import { Store, UpdateStore } from '../../StoreContext';
import useWindowSize from '../../utils/WindowSize';

import { months } from '../../utils/Constants';

const headArr = [
  {
    title: 'Tickets créés',
    // description: 'Tickets créés',
    color: '#5B5B5B',
    background: StatisticsHeadBlackSVG,
    status: 'total'
  },

  {
    title: 'Tickets Pris en compte',
    // description: 'Tickets en cours',
    color: '#FF974D',
    background: StatisticsHeadYellowSVG,
    status: 'inProgress'
  },
  {
    title: 'Tickets résolus',
    // description: 'Tickets résolus',
    color: '#44787B',
    background: StatisticsHeadGreenSVG,
    status: 'completed'
  }
];

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function StatisticsScreen() {
  const navigate = useNavigate();
  const [templatescreen, setTemplatescreen] = useState('');
  const [exportpdf, setExportpdf] = useState(false);
  const { t } = useTranslation();
  const store = Store();
  const updateStore = UpdateStore();
  const [width] = useWindowSize();
  const user = getUser();

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top'
      },
      title: {
        display: true,
        text: 'Tickets'
      }
    },
    layout: {
      padding: {
        top: 20,
        left: width < 992 ? 10 : 100,
        right: width < 992 ? 10 : 100,
        bottom: 20
      }
    },
    scales: {
      y: {
        title: {
          display: true,
          text: 'Nombre de tickets',
          font: {
            size: 12
          }
        }
      }
    },
    maintainAspectRatio: false
  };

  useEffect(() => {
    _load();
  }, []);

  const _load = async () => {
    const _data = await getStatistics();
    const labels = _getLabels(_data.graphicalData);
    const gDataObj = {
      labels,
      datasets: []
    };

    const gDataArr = [];
    for (let i = 0; i < _data.graphicalData.length; i++) {
      let _ = _data.graphicalData[i];
      _ = Object.values(_);
      _ = [_[0], _[2], _[1]];
      gDataArr.push(_);
    }
    const gParsedDataArr1 = gDataArr.map(_ => _[0]);
    const gParsedDataArr2 = gDataArr.map(_ => _[2]);
    const gParsedDataArr3 = gDataArr.map(_ => _[1]);

    const gParsedDataArr = [gParsedDataArr1, gParsedDataArr3, gParsedDataArr2];

    for (let i = 0; i < headArr.length; i++) {
      const obj = headArr[i];
      gDataObj.datasets.push({
        label: obj.title,
        data: gParsedDataArr[i],
        backgroundColor: obj.color
      });
    }

    updateStore({
      statistics: {
        ...store.statistics,
        ..._data,
        gData: gDataObj,
        isLoading: false
      }
    });
  };

  const _getLabels = _ => {
    const arr = [];
    for (let i = 0; i < _.length; i++) {
      const obj = _[i];
      //const date = new Date(obj.transactionDate);
      const date = new Date(obj.startTransactionDate);
      const dateMonth = date.getUTCMonth();
      const dateDay = date.getUTCDate();
      const month = months[dateMonth];
      // const startDay = dateDay - 6 <= 0 ? (check31days ? 31 : 1) : dateDay - 6;
      // const endDay = dateDay;
      //const str = `${month} ${startDay}-${endDay}`;
      const str = `${month} ${obj?.weekPeriod}`;
      arr.push(str);
    }
    return arr;
  };
  const getStatistics = async () => {
    let response;
    try {
      response = await Api('get', `/dashboard/currentweek_casefile_details/${user.id}`);
      const _statistics = response.data.data;
      console.log(_statistics, '_statistics');
      return _statistics;
    } catch (e) {
      console.trace(e);
    }
  };
  const getPdfData = async () => {
    let response;
    try {
      response = await Api('get', `/dashboard/template_casefile_details/${user.id}`);
      console.log(response, 'fg');
      return response?.data?.data;
    } catch (error) {}
  };
  function forceDownload(url, fileName) {
    let xhr = new XMLHttpRequest();

    xhr.open('GET', url, true);
    xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
    xhr.responseType = 'blob';
    xhr.onload = function () {
      var urlCreator = window.URL || window.webkitURL;
      var imageUrl = urlCreator.createObjectURL(this.response);
      var tag = document.createElement('a');
      tag.href = imageUrl;
      tag.download = fileName;
      document.body.appendChild(tag);
      tag.click();
      document.body.removeChild(tag);
    };
    xhr.send();
  }
  const getLinkToDownload = data => {
    console.log(data, 'data');
    let response = Api('put', '/api/graph', data, true);
    return response;
  };
  const navToStatisticsReport = async () => {
    //window.open('/statistics_report', '_blank')
    let data = await getPdfData();
    console.log(data, 'data');
    console.log(data);
    let res = await getLinkToDownload(data);
    forceDownload(res?.data?.link, 'fileName');
  };
  return (
    <UXL appBarText={t('Statistics')}>
      {store.statistics.isLoading ? (
        <Loader
          divStyle={{
            marginTop: '38vh'
          }}
        />
      ) : (
        <div
          className={`${exportpdf ? 'blurClass ' : ''} column background`}
          style={{
            padding:
              store?.sideBarSelectIndex == 1 && width < 993 && width > 667 ? '3% 5%' : '3% 2%',
            width: store?.isSideBar ? '100%' : '100%'
          }}>
          <div
            style={{
              width: store?.isSideBar && width < 992 ? '90%' : '100%',
              paddingLeft:
                store?.isSideBar && width < 667
                  ? '10%'
                  : store?.isSideBar && width < 992
                  ? '5%'
                  : ''
            }}
            className="row w100 header_list_container">
            {headArr.map((_, __) => (
              <HeaderListTile {..._} width={width} count={store.statistics.tilesData[_.status]} />
            ))}
            {console.log(store, 'str')}
          </div>
          <div
            style={{
              width:
                store?.isSideBar && width < 667
                  ? '90%'
                  : store?.isSideBar && width < 992
                  ? '95%'
                  : '100%',
              marginLeft:
                store?.isSideBar && width < 667
                  ? '10%'
                  : store?.isSideBar && width < 992
                  ? '5%'
                  : ''
            }}
            className="bar_conatiner">
            <Bar options={options} data={store.statistics.gData} />
          </div>
          <div
            style={{
              width:
                store?.isSideBar && width < 667
                  ? '90%'
                  : store?.isSideBar && width < 992
                  ? '95%'
                  : '100%',
              marginLeft:
                store?.isSideBar && width < 667
                  ? '10%'
                  : store?.isSideBar && width < 992
                  ? '5%'
                  : ''
            }}
            className="percentage_container">
            {/* <p
              style={{
                marginLeft: '3%',
                padding: '1% 0%',
                color: '#4F4F4F',
                fontWeight: '600',
              }}
            >
              Emplacement avec la plupart des tickets
            </p> */}
            <div className="column w100 building_details_scrollable">
              {store.statistics.buildingTickets.map((_, __) => (
                <div
                  className="row aic"
                  style={{
                    width: '52%',
                    marginBottom: '1%',
                    marginLeft: '6%'
                    //  justifyContent: "space-between",
                  }}>
                  <div className="buildingName_div">
                    <p
                      style={{
                        // paddingLeft: "6%",
                        // paddingRight: "3%",
                        color: _?.color ?? 'black',
                        fontWeight: '600'
                      }}>
                      {_.buildingName.length > 8
                        ? _.buildingName.slice(0, 8) + '...'
                        : _.buildingName}
                    </p>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      marginLeft: '24%',
                      alignItems: 'center'
                    }}>
                    <div
                      style={{
                        height: _.ticketCount > 0 ? '8pt' : '0pt',
                        width: `${10 * (_.ticketCount ?? 0)}pt`,
                        // maxWidth: "5%",
                        maxWidth: '50%',
                        backgroundColor: _.color ?? 'black',
                        borderRadius: '20px',
                        paddingLeft: '6%'
                      }}
                    />

                    <p
                      style={{
                        paddingLeft: '5px',
                        fontSize: '16px',
                        color: _.color ?? 'black'
                      }}>
                      {_.ticketCount ?? 0}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            {exportpdf ? (
              <div className="btn_div">
                <button
                  disabled
                  style={{
                    background: 'rgb(47, 105, 109)',
                    border: 'none',
                    borderRadius: '10px',
                    color: 'white',
                    cursor: 'pointer',
                    padding: '8px 16px',
                    outline: 'none'
                  }}>
                  Loading
                </button>
              </div>
            ) : (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent: 'flex-end',
                  width: '99%',
                  textAlign: 'right'
                  // marginBottom: "5px",
                }}>
                <button
                  onClick={navToStatisticsReport}
                  style={{
                    background: 'rgb(47, 105, 109)',
                    border: 'none',
                    borderRadius: '10px',
                    color: 'white',
                    cursor: 'pointer',
                    padding: '8px 16px',
                    outline: 'none'
                  }}>
                  Exporter les données(.pdf)
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      <div
        className={`${navToStatisticsReport ? 'blurClass2' : ''}`}
        dangerouslySetInnerHTML={{ __html: templatescreen }}
      />
    </UXL>
  );
}

function HeaderListTile(props) {
  return (
    <div className="row aic header_list_tile_container">
      <div className="column tickets_percentage">
        <p
          style={{
            fontSize: props?.width < 400 ? '10px' : '14px',
            fontWeight: '600',
            color: props.color
          }}>
          {props.title}
        </p>
        <p
          style={{
            fontSize: props?.width < 400 ? '6px' : '12px',
            color: props.color
          }}>
          {props.description}
        </p>
      </div>
      <div style={{ position: 'relative' }}>
        <img
          src={props.background}
          style={{
            position: 'absolute',
            height: '60pt',
            width: '100pt',
            left: '-100pt',
            bottom: '-30pt'
          }}
        />
        <p
          style={{
            position: 'absolute',
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#FFFFFF',
            left: '-60pt',
            bottom: '-8pt'
          }}>
          {props.count}
        </p>
      </div>
    </div>
  );
}

export default StatisticsScreen;
